import '../../scss/collection/index.scss';

import {initFilters} from "./filters";

document.addEventListener('DOMContentLoaded', () => {
    initFilters();
});


